import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Switch,
  TextField,
  Tooltip,
  Typography
} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

// Botao "Link do catálogo" da tela de Produtos: liga a pagina publica com os
// produtos disponiveis e escolhe o final do link e o WhatsApp do botao.
const CatalogoPublicoBotao = ({ className }) => {
  const [aberto, setAberto] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [ativo, setAtivo] = useState(false);
  const [slug, setSlug] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [whatsappPadrao, setWhatsappPadrao] = useState("");
  const [slugSalvo, setSlugSalvo] = useState("");

  const base = `${window.location.origin}/catalogo/`;
  const link = `${base}${slugSalvo}`;

  const abrir = async () => {
    setAberto(true);
    setCarregando(true);
    try {
      const { data } = await api.get("/catalogo-publico");
      setAtivo(!!data.ativo);
      setSlug(data.slug || "");
      setSlugSalvo(data.ativo ? data.slug || "" : "");
      setWhatsapp(data.whatsapp || "");
      setWhatsappPadrao(data.whatsappPadrao || "");
    } catch (err) {
      toastError(err);
    } finally {
      setCarregando(false);
    }
  };

  const salvar = async () => {
    setSalvando(true);
    try {
      const { data } = await api.put("/catalogo-publico", { ativo, slug, whatsapp });
      setSlug(data.slug);
      setSlugSalvo(data.ativo ? data.slug : "");
      setWhatsapp(data.whatsapp || "");
      toast.success(data.ativo ? "Catálogo público ligado!" : "Catálogo público desligado");
    } catch (err) {
      toastError(err);
    } finally {
      setSalvando(false);
    }
  };

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Link copiado!");
    } catch (e) {
      toast.info(link);
    }
  };

  return (
    <>
      <Button variant="outlined" color="primary" startIcon={<LinkIcon />} onClick={abrir} className={className}>
        Link do catálogo
      </Button>
      <Dialog open={aberto} onClose={() => setAberto(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Catálogo público</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Uma página com os produtos <b>disponíveis</b>, com fotos, preço e o botão "Pedir pelo WhatsApp". Qualquer pessoa
            com o link abre, sem login. Bom para a bio do Instagram, o status e os anúncios.
          </Typography>
          {carregando ? (
            <Typography variant="body2" style={{ padding: "24px 0" }}>Carregando…</Typography>
          ) : (
            <Box display="flex" flexDirection="column" style={{ gap: 16, marginTop: 8 }}>
              <FormControlLabel
                control={<Switch checked={ativo} onChange={e => setAtivo(e.target.checked)} color="primary" />}
                label={ativo ? "Ligado: qualquer pessoa com o link vê o catálogo" : "Desligado: o link não abre"}
              />
              <TextField
                label="Final do link"
                variant="outlined"
                size="small"
                value={slug}
                onChange={e => setSlug(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, "-"))}
                helperText="Só letras minúsculas, números e hífen"
                InputProps={{ startAdornment: <InputAdornment position="start">{base}</InputAdornment> }}
              />
              <TextField
                label="WhatsApp do botão (opcional)"
                variant="outlined"
                size="small"
                value={whatsapp}
                onChange={e => setWhatsapp(e.target.value)}
                placeholder={whatsappPadrao || "5511999998888"}
                helperText={
                  whatsappPadrao
                    ? `Vazio = o número da conexão padrão (${whatsappPadrao})`
                    : "Com DDD. Sem número, o catálogo aparece sem o botão do WhatsApp"
                }
              />
              {slugSalvo && (
                <Box
                  display="flex"
                  alignItems="center"
                  style={{ gap: 4, background: "rgba(0,0,0,.04)", borderRadius: 8, padding: "6px 6px 6px 12px" }}
                >
                  <Typography variant="body2" style={{ flex: 1, wordBreak: "break-all" }}>{link}</Typography>
                  <Tooltip title="Copiar link">
                    <IconButton size="small" onClick={copiar}><FileCopyOutlinedIcon fontSize="small" /></IconButton>
                  </Tooltip>
                  <Tooltip title="Abrir">
                    <IconButton size="small" component="a" href={link} target="_blank" rel="noopener noreferrer">
                      <OpenInNewIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAberto(false)}>Fechar</Button>
          <Button color="primary" variant="contained" onClick={salvar} disabled={salvando || carregando}>
            {salvando ? "Salvando…" : "Salvar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CatalogoPublicoBotao;
